<template>
  <div class="notifications" style="min-height: 20rem">
    <popup-file-preview />
    <popup-about-profile />

    <h2 class="no-margin">Все уведомления</h2>
    <div class="pure-g container filters margin-half-t">
      <div class="pure-u-1 h2 margin-half-b">
        Фильтры {{ page }} {{ notifications.length }}
        <button class="btn btn-small" @click="reset"><i class="fa fa-undo margin-half-r"></i> Сбросить</button>
      </div>
      <div class="pure-u-1 pure-u-md-1-4">
        <users-picker v-model="filterFrom" placeholder="От кого"/>
      </div>
      <div class="pure-u-1 pure-u-md-1-4">
        <select v-model="filterProjectId" @change="onFilterChanged">
          <option value="">Все проекты</option>
          <option :value="p.id" v-for="p in projects" :key="'project_' + p.id">{{ p.name }}</option>
        </select>
      </div>
      <div class="pure-u-1 pure-u-md-1-4">
        <v-date-picker v-model="filterDates" @change="onFilterChanged" is-range>
          <template v-slot="{ inputEvents }">
            <input readonly :value="filterDatesText" type="text" v-on="inputEvents.start"/>
          </template>
        </v-date-picker>
      </div>
      <div class="pure-u-1 form-row">
        <div class="flex-row">
          <label class="block-vcenter margin-r">
            <input v-model="unreadOnly" @change="onFilterChanged" type="checkbox" class="margin-half-r"/>
            Только непрочитанные
          </label>
          <label class="block-vcenter margin-r">
            <input v-model="includeNotifications" @change="onFilterChanged" type="checkbox" class="margin-half-r"/>
            Показать изменения в проекте
          </label>
          <label class="block-vcenter margin-r">
            <input v-model="includeChatNotifications" type="checkbox" @change="onFilterChanged" class="margin-half-r"/>
            Показать новые сообщения
          </label>
        </div>
      </div>
    </div>

    <div class="txt-r">
      <button @click="readAllAssignments" class="btn">Прочитать все с назначениями</button>
    </div>

    <vue-element-loading :active="isNotificationsLoading"/>
    <vuescroll style="min-height: 50vh">
      <template v-for="(n, index) in notifications">
        <div class="header" v-if="index == 0 || (notifications[index-1].project.id != n.project.id)" :key="'project-thead-' + n.project.id + '_' + index">
            <h3>{{ n.project.name }}</h3>
        </div>
        <div class="padding-h" v-if="n.theme" :key="'theme_' + n.theme.id + '_' + index">
          <stage-entry-theme :tuser="n" :task="n.task" :project="n.project" :showTask="true" />
        </div>
        <div class="padding-h" v-else :key="'notifications_' + n.id + '_' + index">
          <stage-entry :stage="n.taskStage" :group="n.task.group" :task="n.task" :project="n.project" :showTask="true" />
        </div>
      </template>
      <div class="pure-u-1 margin-t">
        <div class="pure-u-1 pure-u-md-1-3"></div>
        <div class="pure-u-1 pure-u-md-1-3" txt-c>
          <button class="btn" v-show="!isAllLoaded" @click="page++; loadNotifications();">
            Загрузить еще
          </button>
        </div>
        <div class="pure-u-1 pure-u-md-1-3 txt-r">
          <button class="btn btn-primary" @click="readAll">
            Прочитать все
            <span v-if="selectedProject">в проекте {{ selectedProject.name }}</span>
            <span v-else>во всех проектах</span>
          </button>
        </div>
      </div>
    </vuescroll>
  </div>
</template>

<style scoped>
:not(.vm--modal) .scroll-wrp {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
}

.notifications {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
}

table {
  position: relative;
  overflow: hidden;
  width: 100%;
  border-collapse: collapse;
}
table tr, table td {
  box-sizing: border-box;
}

table .header {
  z-index: 1;
  height: 2rem;
  font-size: .8em;
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3);
}

table .header td {
  padding: .25em .5em;
  border: 1px solid #666;
  border-left-width: 2px;
  border-right-width: 2px;
  font-weight: 700;
}

table td {
  height: 2.2em;
  font-size: .9rem;
  border: 1px solid #666;
  border-left-width: 2px;
  border-right-width: 2px;
  background-color: #FFF;
  transition: all .2s;
}
</style>

<script>
import VueElementLoading from 'vue-element-loading'
import vuescroll from 'vuescroll'

import PopupFilePreview from '@/components/PopupFilePreview.vue'
import PopupAboutProfile from '@/components/PopupAboutProfile.vue'
import StageEntry from '@/components/StageEntry.vue'
import StageEntryTheme from '@/components/StageEntryTheme.vue'
import UsersPicker from '@/components/UsersPicker.vue'

import { mapGetters } from "vuex"
import apiCall from '@/utils/api'
import { NOTIFICATIONS_REQUEST } from "@/store/actions/notifications"

export default {
  name: 'Notifications',
  components: {
    VueElementLoading,
    UsersPicker,
    StageEntry,
    StageEntryTheme,
    PopupFilePreview,
    PopupAboutProfile,
    vuescroll
  },
  props: ['projectId'],
  data() {
    return {
      isNotificationsLoading: false,
      filterFrom: [],
      filterProjectId: '',
      filterDates: {start: null, end: null},
      unreadOnly: true,
      includeNotifications: true,
      includeChatNotifications: true,
      page: 1,
      pageSize: 100,
      isAllLoaded: false,
      projects: [],
      notifications: [],
    }
  },
  watch: {
    filterFrom() {
      this.onFilterChanged()
    },
    filterDates() {
      this.onFilterChanged()
    }
  },
  computed: {
    ...mapGetters(["authId", "groupsKeyed", "activeGroup", "activeProject"]),
    selectedProject() {
      if (!this.filterProjectId) {
        return null
      }
      return this.projects.find(p => p.id == this.filterProjectId)
    },
    filterDatesText() {
      let text = ""
      if (this.filterDates.start) {
        text += " от " + this.filterDates.start.toLocaleDateString("ru-RU")
      }
      if (this.filterDates.end) {
        text += " до " + this.filterDates.end.toLocaleDateString("ru-RU")
      }
      return text.trim()
    }
  },
  mounted() {
    this.filterProjectId = this.projectId

    this.loadNotifications()
    this.loadProjects()
    
    this.$sodnpHub.$on('task-added', this.onTaskAdded)
    this.$sodnpHub.$on('task-updated', this.onTaskUpdated)
  },
  beforeDestroy: function() {
    this.$sodnpHub.$off('task-added', this.onTaskAdded)
    this.$sodnpHub.$off('task-updated', this.onTaskUpdated)
  },
  methods: {
    async loadNotifications() {
      if (this.isNotificationsLoading) {
        return
      }

      this.isNotificationsLoading = true
      if (this.page == 1) {
        this.isAllLoaded = false
        this.notifications = []
        this.chatNotifications = []
      }
      var action = "projects/notifications?"
      var chatAction = "projects/chat-notifications?"
      var queryParams = {
        page: this.page,
        pageSize: this.pageSize
      }
      if (!this.unreadOnly) {
        queryParams.unreadOnly = "false"
      }
      if (this.filterProjectId) {
        queryParams.projectId = this.filterProjectId
      }
      if (this.filterFrom && this.filterFrom.length) {
        queryParams["fromIds"] = this.filterFrom.join(",")
      }
      if (this.filterDates.start && this.filterDates.end) {
        queryParams.dateFrom = new Date(this.filterDates.start).toISOString()
        queryParams.dateTo = new Date(this.filterDates.end).toISOString()
      }
      action += Object.keys(queryParams).map(k => k + "=" + queryParams[k]).join("&")
      chatAction += Object.keys(queryParams).map(k => k + "=" + queryParams[k]).join("&")

      let resp = {notifications: []}
      let chatResp = {chatNotifications: []}
      const includeBoth = !this.includeChatNotifications && !this.includeNotifications
      if (this.includeNotifications || includeBoth) {
        resp = await apiCall({ url: action, method: "GET"})
      }
      if (this.includeChatNotifications || includeBoth) {
        chatResp = await apiCall({ url: chatAction, method: "GET"})
      }
      if (resp.notifications.length < this.pageSize && chatResp.chatNotifications.length < this.pageSize) {
        this.isAllLoaded = true
      }
      
      resp.notifications.map(n => n._tabId = this.groupsKeyed[n.groupId] ? this.groupsKeyed[n.groupId].tabId : null)
      let notifiactions = resp.notifications.concat(chatResp.chatNotifications).sort(function(a,b){
        const dateA = new Date(a.theme ? a.theme.lastMessageAt : a.visibleSince)
        const dateB = new Date(b.theme ? b.theme.lastMessageAt : b.visibleSince)
        if (dateA >= dateB)
          return -1;
        return 1;
      });

      this.notifications = this.notifications.concat(notifiactions)
      this.page += 1
      this.isNotificationsLoading = false

    },
    loadProjects() {
      apiCall({ url: "projects", method: "GET" })
			.then(resp => {
				this.projects = resp
			})
    },
    onFilterChanged() {
      this.page = 1
      this.loadNotifications()
    },
    onTaskUpdated() {
      this.loadNotifications()
    },
    onTaskAdded() {
      this.loadNotifications()
    },
    readAllAssignments() {
      apiCall({ url: "notifications/read-all/assigns", method: "POST"})
        .then(() => {
          this.$store.dispatch(NOTIFICATIONS_REQUEST)
          this.loadNotifications()
        })
    },
    readAll() {
      if (!confirm("Вы уверены, что хотите прочитать все уведомления? Это действие необратимо!")) {
        return
      }
      let url = "notifications/read-all"
      if (this.filterProjectId) {
        url += "?projectId=" + this.filterProjectId
      }
      apiCall({url: url, method: "POST"})
        .then(() => {
          this.$store.dispatch(NOTIFICATIONS_REQUEST)
          this.loadNotifications()
        })
    },
    reset() {
      this.filterFrom.splice(0)
      this.filterDates = {start: null, end: null}
      this.unreadOnly = true
      this.filterProjectId = this.projectId ?? this.activeProject.id ?? ''
      this.onFilterChanged()
    }
  }
}
</script>
